import { BaseEntity } from 'yt-ng-framework';
import { stringify } from 'querystring';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class UgovorRoView extends BaseEntity {
  constructor(){
      super();
  }
  RadnoVreme:string;
  Delovodnik:string;
  MestoRada:string;
  RadnoMesto:string;
  TipDokumenta:string;
  StatusRo:string;
  Valuta:string;
  Osoba:string;
  Objekat:string;
  Beneficirani:string;
  OrgJedRada:string;
  Broj:string;
  Datum:NgbDate;
  OdDatuma:NgbDate;
  DoDatuma:NgbDate;
  KoefZarade:number;
  NetoZarada:number;
  BrutoZarada:number;
  PrcAng:number;
  NedFondSati:number;
  BrutoCenaSata:number;
  NetoCenaSata:number;
  BrojSmena:number;
  BrojPoslodavaca:number;
  Ugovoren:boolean;
  Color:string="Red";

  Deserialize(input: any){
      this.ID = input.ID;
      this.RadnoVreme=input.RadnoVreme;
      this.Delovodnik = input.Delovodnik;
      this.MestoRada = input.MestoRada;
      this.RadnoMesto = input.RadnoMesto;
      this.TipDokumenta = input.TipDokumenta;
      this.StatusRo = input.StatusRo;
      this.Valuta = input.Valuta;
      this.Osoba = input.Osoba;
      this.Objekat = input.Objekat;
      this.Beneficirani = input.Beneficirani;
      this.OrgJedRada = input.OrgJedRada;
      this.Broj = input.Broj;
      this.Datum = input.Datum;
      this.OdDatuma = input.OdDatuma;
      this.DoDatuma = input.DoDatuma;
      this.KoefZarade = input.KoefZarade;
      this.NetoZarada = input.NetoZarada;
      this.BrutoZarada = input.BrutoZarada;
      this.PrcAng = input.PrcAng;
      this.NedFondSati = input.NedFondSati;
      this.BrutoCenaSata = input.BrutoCenaSata;
      this.NetoCenaSata = input.NetoCenaSata;
      this.BrojSmena = input.BrojSmena;
      this.BrojPoslodavaca = input.BrojPoslodavaca;
      this.Ugovoren = input.Ugovoren;
      this.Color=input.Color;

      return this;
  }

  Serialize(input: UgovorRoView){
      return input;
  }
}
